import enviro from 'enviro';
import debug from 'growth-payments-core/debug/console';
import { useQueryStringState } from 'growth-payments-core/query-string/useQueryStringState';
import { CrmSubscreenToModalDisplayMap, MeetingsPaymentLinkStatusToModalDisplayMap } from '../components/Modals';
import { ModalDisplay } from '../types/paymentsInterstitialModal';
import { Screen, Subscreen, getIsCrmSubscreen } from '../types/screen';
import useEmbeddedPoint from './useEmbeddedPoint';
import { useEligibilityBinding } from 'growth-payments-core/eligibility/eligibilityBinding';
import { UnderwritingStatus } from 'growth-payments-core/eligibility/types';
import usePaymentLinkStatus from './toolStatus/usePaymentLinkStatus';
const useModalToDisplay = ({
  screen,
  subscreen
}) => {
  const [eligibility] = useEligibilityBinding();
  const {
    display: legacyModalToDisplay
  } = useEmbeddedPoint();
  const {
    paymentLinkStatus
  } = usePaymentLinkStatus();
  if (screen === Screen.EMAIL || screen === Screen.CMS || screen === Screen.UNKNOWN) {
    return ModalDisplay.ENROLL_WITH_PAYMENT_LINKS;
  }
  if (screen === Screen.MEETINGS) {
    return MeetingsPaymentLinkStatusToModalDisplayMap[paymentLinkStatus];
  }
  if (subscreen === Subscreen.INVOICE_CUSTOMIZATION || subscreen === Subscreen.INVOICE_AUTOMATION) {
    return ModalDisplay.ENROLL_WITH_INVOICES;
  }
  if (screen === Screen.WORKFLOWS && subscreen === Subscreen.TEMPLATES) {
    return ModalDisplay.COLLECT_PAYMENTS;
  }

  /**
   * CRM is the only screen getting different treatments
   */
  if (!getIsCrmSubscreen(subscreen)) return legacyModalToDisplay;
  if (eligibility && eligibility.underwritingStatus && eligibility.underwritingStatus === UnderwritingStatus.IN_UNDERWRITING) return ModalDisplay.NONE;
  return CrmSubscreenToModalDisplayMap[subscreen];
};
export const useEmbedPointModalDisplay = ({
  screen,
  subscreen
}) => {
  // displayOverride allows us to override the computed state for debugging.
  const [displayOverride] = useQueryStringState('override-display', undefined);
  debug.log('displayOverride', displayOverride);
  const modalToDisplay = useModalToDisplay({
    screen,
    subscreen
  });
  return enviro.isProd() ? modalToDisplay : displayOverride || modalToDisplay;
};